import { render, staticRenderFns } from "./companyBranding.vue?vue&type=template&id=65fe35ca&scoped=true"
import script from "./companyBranding.vue?vue&type=script&lang=js"
export * from "./companyBranding.vue?vue&type=script&lang=js"
import style0 from "./companyBranding.vue?vue&type=style&index=0&id=65fe35ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fe35ca",
  null
  
)

export default component.exports